import request from './request'

// 获取用户企业列表
export function getApplication (data) {
  return request({
    url: 'Application/ApplicationPublishConfig?language=' + data.language + '&plantform=' + data.plantform,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/client.api.js